/* eslint-disable @typescript-eslint/no-explicit-any */
const idSet = (window._SVG_SPRITE_IDS_ =
    window._SVG_SPRITE_IDS_ || []);
export const spriteNodeId = '__SVG_SPRITE_NODE__';
// Vendored copy — see ./vendor/svg-baker-runtime/README.md. The type-only imports keep the
// DefinitelyTyped declarations the package was typed with; they are erased at emit, so nothing
// from svg-baker-runtime is loaded at runtime.
import VendoredBrowserSymbol from './vendor/svg-baker-runtime/browser-symbol.js';
import VendoredBrowserSprite from './vendor/svg-baker-runtime/browser-sprite.js';
const BrowserSpriteSymbol = VendoredBrowserSymbol;
const BrowserSprite = VendoredBrowserSprite;
const svgSpriteSheet = new BrowserSprite({
    attrs: {
        id: '__SVG_SPRITE_NODE__',
    },
});
if (!window['svgSpriteSheet']) {
    window['svgSpriteSheet'] = svgSpriteSheet;
}
export default function addSymbol({ id, viewBox, content, }) {
    if (idSet.indexOf(id) > -1 || document.getElementById(id)) {
        console.warn(`Icon #${id} was duplicately registered. It must be globally unique.`);
    }
    window['svgSpriteSheet'].add(new BrowserSpriteSymbol({
        id,
        viewBox,
        content,
    }));
}
export { BrowserSprite, BrowserSpriteSymbol };
